<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

export default {
  metaInfo() {
    const { title } = this.$route.meta || {}
    const projectTitle = process.env.VUE_APP_TITLE
    return {
      title: title ? `${projectTitle} - ${title}` : projectTitle
    }
  },
  data() {
    return { zh_CN }
  }
}
</script>

<style lang="less">
#app {
  height: 100%;
}
</style>
